import { Routes } from '@angular/router'
import { SignInComponent } from './pages/sign-in/sign-in.component'
import { SignUpComponent } from './pages/sign-up/sign-up.component'
import { ThankYouComponent } from './pages/thank-you/thank-you.component'
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component'
import { CounsellingModeComponent } from './pages/counselling-mode/counselling-mode.component'
import { AuthRedirectComponent } from './pages/auth-redirect/auth-redirect.component'
import { canActivateRoute } from './common/api/services/routing-guard'
import { canActivateLanding } from './common/api/services/landing-routing-guard'
import { canActivateSignin } from './common/api/services/signin-routing-guard'

export const routes: Routes = [
  { path: 'redirect', component: AuthRedirectComponent },
  { path: 'landing', component: CounsellingModeComponent, canActivate: [canActivateLanding] },
  { path: 'signin', component: SignInComponent, canActivate: [canActivateSignin] },
  { path: '', component: CounsellingModeComponent, canActivate: [canActivateLanding] },
  { path: 'signup', component: SignUpComponent, canActivate: [canActivateRoute] },
  { path: 'thankyou', component: ThankYouComponent },
  { path: 'error', component: PageNotFoundComponent }
]
